export interface FeeBounds
{
    min: number;
    max: number;
    increment: number;
}

export type FeeUnit = '%' | '£';

const EPSILON = 1e-9;

const isMultipleOf = (value: number, increment: number): boolean =>
{
    if (increment <= 0) return true;
    const ratio = value / increment;
    return Math.abs(ratio - Math.round(ratio)) < EPSILON;
};

export const isValidFee = (value: number, bounds: FeeBounds): boolean =>
{
    if (!Number.isFinite(value)) return false;
    const { min, max, increment } = bounds;
    
    if (Math.abs(value - min) < EPSILON || Math.abs(value - max) < EPSILON) return true;
    return value >= min - EPSILON
        && value <= max + EPSILON
        // Whole numbers stay valid whatever the band's increment is; the increment only widens
        // what is accepted (ST&R's 2.5 band allows 22.5 as well as 22 and 23).
        && (isMultipleOf(value, 1) || isMultipleOf(value, increment));
};

export const exampleFee = (bounds: FeeBounds, entered?: number): number =>
{
    const { min, max, increment } = bounds;
    const base = Number.isFinite(entered as number) ? (entered as number) : min;
    if (base <= min) return min;
    if (base >= max) return max;
    const snapped = increment > 0 ? Math.round(base / increment) * increment : base;
    if (snapped < min) return min;
    if (snapped > max) return max;
    return snapped;
};

export const formatFee = (value: number, unit: FeeUnit): string =>
    unit === '£' ? `£${value}` : `${value}%`;

export const stepLabel = (increment: number): string =>
    increment === 1 ? 'whole numbers' : `whole numbers or steps of ${increment}`;
